import { useState } from 'react'

import { Text, Primary13Regular, Flex } from '@sequencehq/core-components'
import { format } from '@sequencehq/utils/dates'
import { AggregatedCreditNote } from 'CreditNotes/types'
import { SummaryRow } from './SummaryRow'
import { SummaryRowEditButton } from './SummaryRowEditButton'
import { usePermissions } from 'lib/rbac'
import { CreditNoteAccountingDatePicker } from './CreditNoteAccountingDatePicker'

type Props = {
  updateTaxDate: (taxDate: AggregatedCreditNote['taxDate']) => void
  taxDate?: AggregatedCreditNote['taxDate']
  status: AggregatedCreditNote['status']
}

export const CreditNoteTaxDate = ({
  updateTaxDate,
  taxDate,
  status
}: Props) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false)

  const formattedTaxDate = taxDate
    ? format(new Date(taxDate), 'd MMM yyyy')
    : '-'

  const handleChange = (newTaxDate: string) => {
    updateTaxDate(newTaxDate)
    setIsPickerOpen(false)
  }

  const { can } = usePermissions()
  const canEdit = status === 'DRAFT' && can('org.creditNote:update')

  return (
    <SummaryRow
      label="Tax date"
      value={
        <Flex alignItems="center" gap={1} role="group">
          {isPickerOpen ? (
            <CreditNoteAccountingDatePicker
              accountingDate={taxDate}
              onChange={handleChange}
              openOnMount={true}
              data-testid="creditNote.taxDate.picker"
            />
          ) : (
            <>
              <Text
                {...Primary13Regular}
                data-testid="creditNote.taxDate.readOnly"
              >
                {formattedTaxDate}
              </Text>
              {canEdit && (
                <SummaryRowEditButton
                  aria-label="Edit tax date"
                  data-testid="creditNote.taxDate.edit"
                  onClick={() => setIsPickerOpen(true)}
                />
              )}
            </>
          )}
        </Flex>
      }
    />
  )
}
